'use client';

import { useEffect, useState } from 'react';

import {
    Align,
    Box,
    BoxContent,
    Column,
    Columns,
    Icon,
    IconColor,
    IconName,
    IconSize,
    Link,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';

import { TradeInStep } from '@constants/trade-in';

import { getTradeInStep } from '@product-detail/helpers';

type TicketTradeInProps = {
    tradeInBonus: number;
    tradeInStep: TradeInStep;
    openTradeInModal: () => void;
};

export function TicketTradeIn({ tradeInBonus, openTradeInModal, tradeInStep }: Readonly<TicketTradeInProps>) {
    const [isTradeInShowed, setIsTradeInShowed] = useState<boolean>(true);
    const [tradeInPhone, setTradeInPhone] = useState<string>('');
    const [tradeInPrice, setTradeInPrice] = useState<number>(0);

    useEffect(() => {
        if (tradeInStep === TradeInStep.CONFIRMED) {
            const product = getTradeInStep(TradeInStep.SEARCH);
            const tradeIn = getTradeInStep(TradeInStep.CONFIRMATION);
            if (tradeInPhone !== product?.name) {
                setTradeInPhone(product?.name ?? '');
                setTradeInPrice(tradeIn?.amount ?? 0);
            }
        }
    }, [tradeInStep]);

    return (
        <>
            <Spacer size={SpacerSize.FIVE} />
            <Box shadowless>
                <BoxContent backgroundColor={TrilogyColor.MAIN_FADE} className='p-small'>
                    <Columns mobile verticalAlign={Align.CENTER} gap={2} marginless>
                        <Column narrow>
                            <Icon
                                size={IconSize.SMALL}
                                color={IconColor.MAIN}
                                name={isTradeInShowed ? IconName.ARROW_DOWN : IconName.ARROW_UP}
                                onClick={() => setIsTradeInShowed(!isTradeInShowed)}
                                className='cursor-pointer'
                            />
                        </Column>
                        <Column>
                            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO} marginless>
                                Reprise mobile
                            </Text>
                        </Column>
                        <Column narrow>
                            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO} marginless>
                                <InlinePrice level={TextLevels.TWO} amount={-tradeInPrice - tradeInBonus} />
                            </Text>
                        </Column>
                    </Columns>
                    {isTradeInShowed && (
                        <>
                            <Spacer size={SpacerSize.THREE} />
                            <Columns mobile>
                                <Column>
                                    <Text level={TextLevels.THREE}>{`Valeur estimée ${tradeInPhone}`}</Text>
                                    {tradeInBonus > 0 && (
                                        <Text level={TextLevels.THREE} marginless>
                                            Bonus reprise
                                        </Text>
                                    )}
                                    <Text level={TextLevels.FOUR}>En remise différée</Text>
                                    <Text level={TextLevels.THREE}>
                                        <Link onClick={openTradeInModal} role='button'>
                                            Modifier
                                        </Link>
                                    </Text>
                                </Column>
                                <Column narrow className='has-text-right'>
                                    <Text level={TextLevels.THREE}>
                                        <InlinePrice level={TextLevels.TWO} amount={-tradeInPrice} />
                                    </Text>
                                    {tradeInBonus > 0 && (
                                        <Text level={TextLevels.THREE}>
                                            <InlinePrice level={TextLevels.TWO} amount={-tradeInBonus} />
                                        </Text>
                                    )}
                                </Column>
                            </Columns>
                        </>
                    )}
                </BoxContent>
            </Box>
        </>
    );
}
